import React from 'react';

export default function UploadButton(props) {
  return (
    <button>Upload!</button>
  );
}